import { HeaderToolbar } from "@xola/ui-kit";
import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { useSearchAutoFocus } from "../../hooks/useSearchAutoFocus";

interface ProductSearchProps {
    onSearch: (value: string) => void;
}

export const ProductSearch = ({ onSearch }: ProductSearchProps) => {
    const shouldAutoFocus = useSearchAutoFocus();
    const [search, setSearch] = useState("");
    const [debouncedSearch] = useDebounce(search.trim(), 500);

    useEffect(() => {
        onSearch(debouncedSearch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearch]);

    return (
        <span className="relative w-full flex-1">
            <HeaderToolbar.Search
                shouldHideMenu
                autoFocus={shouldAutoFocus}
                shouldStayOpen={false}
                placeholder="Search by name"
                onChange={setSearch}
            />
        </span>
    );
};
